import React from 'react';

const SearchFilterSort = () => {
    return (
        <div className="w-full px-4 py-6" data-aos="flip-left">
            <div className="flex flex-col md:flex-row items-center gap-4 justify-between flex-wrap">

                {/* Filter Button */}
                <button className="flex items-center bg-[#1D1753] text-white px-4 py-2 rounded-lg shadow-sm w-full md:w-auto justify-center gap-4">
                    <span className="text-xl">🔽</span>
                    <div className="w-px h-5 bg-white/30"></div>
                    <span className="text-sm">Filter university</span>
                </button>

                {/* Sort Button */}
                <div className="flex items-center border border-gray-300 bg-white px-4 py-2 rounded-lg shadow-sm w-full md:w-auto gap-2">
                    <span className="text-xl">↕️</span>
                    <div className="w-px h-5 bg-gray-300"></div>
                    <select
                        className="text-sm text-gray-700 bg-white focus:outline-none"
                        defaultValue="popularity"
                    >
                        <option value="popularity">Sort by: Popularity</option>
                        <option value="rating">Sort by: Rating</option>
                        <option value="newest">Sort by: Newest</option>
                        <option value="price_low_high">Sort by: Price (Low to High)</option>
                        <option value="price_high_low">Sort by: Price (High to Low)</option>
                    </select>
                </div>


                {/* Search Input */}
                <div className="flex w-full md:flex-1 max-w-xl rounded-md border border-gray-300 overflow-hidden shadow-sm">
                    <input
                        type="text"
                        placeholder="Search for subjects by keywords"
                        className="flex-grow px-4 py-2 text-sm focus:outline-none"
                    />
                    <button className="bg-[#EA1D2A] text-white w-10 h-10 rounded-md flex items-center justify-center m-2">
                        <span className="text-xl font-bold">→</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchFilterSort;
